class Utils {
	static rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

	static genitiveMonths = {
		január: "januára",
		február: "februára",
		marec: "marca",
		apríl: "apríla",
		máj: "mája",
		jún: "júna",
		júl: "júla",
		august: "augusta",
		september: "septembra",
		október: "októbra",
		november: "novembra",
		december: "decembra",
	};

	static getReadMoreButtonEl(){
		const readMoreButton = document.createElement("button");
		readMoreButton.classList.add("read-more");
		readMoreButton.textContent = "Čítať ďalej";
		return readMoreButton;
	}

	static getRelativeTimestamp( unixTime ){

		if (!unixTime){
			return "";
		}
		
		const currentDatetime = new Date();
  		const postDatetime = new Date(unixTime * 1000);
  		
		const yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
  
		const timeFormatOptions = { hour: '2-digit', minute: '2-digit' };
		const dateFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };

		const timeString = postDatetime.toLocaleTimeString(undefined, timeFormatOptions);
		const dateString = postDatetime.toLocaleDateString(undefined, dateFormatOptions);

		if (this.isSameDay(postDatetime, currentDatetime)) {
			return timeString;
		} else if (this.isSameDay(postDatetime, yesterday)) {
			return `Včera o ${timeString}`;
		} else {
			return dateString;
		}
	}

	static isSameDay( day1, day2 ){
		return 	day1.getFullYear() === day2.getFullYear() &&
				day1.getMonth()    === day2.getMonth() &&
				day1.getDate() 	   === day2.getDate();
	}


	/**
	* Makes an item collapsible if its height exceeds the specified maximum height in rem.
	* @param {HTMLElement} item - The item to make collapsible.
	* @param {number} maxRemHeight - The maximum height in rem before the item becomes collapsible. 
	*/
	static makeItemCollapsibleByHeight( item, maxRemHeight = 20, expandLabelText = "Čítať ďalej" ){
		if(!item){
			return;
		}

		const itemHeight = item.getBoundingClientRect().height;
		const itemRemHeight = itemHeight / this.rootFontSize;

		if(itemRemHeight < maxRemHeight){
			return;
		}

		item.classList.add("collapsed-item");

		const readMoreButton = this.getReadMoreButtonEl();
		readMoreButton.textContent = expandLabelText;

		item.style.maxHeight = `${maxRemHeight}rem`;

		readMoreButton.addEventListener("click", function() {
			item.classList.toggle("collapsed-item");

			if (item.classList.contains("collapsed-item")) {
				item.style.maxHeight = `${maxRemHeight}rem`;
			} else {
				item.style.maxHeight = "none";
			}

			this.textContent = this.textContent === expandLabelText ? "Skryť" : expandLabelText;
		});
			
		item.parentNode.insertBefore(readMoreButton, item.nextSibling);


	}

	/**
	 * Makes an item collapsible by limiting the number of words displayed.
	 * 
	 * If the word count limit break happens to occur inside of a child element (such as a <strong> or <a>),
	 * it will instead be moved to the end of the element to preserve valid HTML structure.
	 * @param {HTMLElement} item - The item to make collapsible.
	 * @param {number} maxWordCount - The maximum number of words to display before collapsing. Default is 50.
	 * */
	static makeItemCollapsibleByWords( item, maxWordCount = 50 ){
		if (!item) {
			return;
		}
		const contentNodes = Array.from(item.childNodes)

		let totalWordCount = 0;
		let targetNode = null;
		let relativeWordPos = 0;

		textNodeLoop: for (let i = 0; i < contentNodes.length; i++) {
			const node = contentNodes[i];
			const words = contentNodes[i].textContent.trim().split(/\s+/).filter(word => word.length > 0);

			relativeWordPos = 0;

			for (let j = 0; j < words.length; j++) {
				const word = words[j];
				if (word.length > 0) {
					totalWordCount++;
					relativeWordPos++;
				}

				if (totalWordCount >= maxWordCount) {
					targetNode = node;
					break textNodeLoop;
				}
			}
		}

		if (targetNode === null) {
			return;
		}

		const readMoreButton = this.getReadMoreButtonEl();

		const ellipsis = document.createElement("span");
		ellipsis.textContent = "...";
		ellipsis.classList.add("ellipsis");
		
		const hiddenContentWrapper = document.createElement('div');
		hiddenContentWrapper.className = 'hidden-content-wrapper';

		if (targetNode.tagName === undefined) {
			const words = targetNode.data.trim().split(/\s+/).filter(word => word.length > 0);
			const firstPart = " " + words.slice(0, relativeWordPos).join(" ") + " ";
			const secondPart = " " + words.slice(relativeWordPos).join(" ") + " ";

			targetNode.textContent = firstPart;
			hiddenContentWrapper.textContent = secondPart;
		}
		
		targetNode.parentNode.insertBefore(ellipsis, targetNode.nextSibling);

		let current = ellipsis.nextSibling;
		while (current) {
		  const next = current.nextSibling;
		  hiddenContentWrapper.appendChild(current);
		  current = next;
		}

		item.classList.add("collapsed-item");
		item.appendChild(hiddenContentWrapper);
		item.parentNode.insertBefore(readMoreButton, item.nextSibling);

		let contentExpanded = false;
		hiddenContentWrapper.style.maxHeight = "0";

		readMoreButton.addEventListener("click", function() {
			contentExpanded = !contentExpanded;

			if (contentExpanded) {
				item.classList.remove("collapsed-item");
				hiddenContentWrapper.style.maxHeight = "none";
				hiddenContentWrapper.style.display = "inline";
				readMoreButton.textContent = "Skryť";
				ellipsis.style.display = "none";
			} else {
				item.classList.add("collapsed-item");
				hiddenContentWrapper.style.maxHeight = "0";
				hiddenContentWrapper.style.display = "none";
				readMoreButton.textContent = "Čítať ďalej";
				ellipsis.style.display = "inline";
			}
		});

	}

	static debounce(fn, delay) {
		var timer = null;
		return function () {
			var context = this, args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				fn.apply(context, args);
			}, delay);
		};
	}

	static getSlovakDateFormat( input ){
		const date = new Date(input);
		const day = date.getDate();
		const year = date.getFullYear();

		const monthFormatter = new Intl.DateTimeFormat('sk-SK', { month: 'long' });
		const monthNominative = monthFormatter.format(date);
		const monthGenitive = this.genitiveMonths[monthNominative];

		return `${day}. ${monthGenitive} ${year}`;
	}

	static toggleLoading(isLoading, node){
		if(isLoading){
		node.classList.add('is-loading');
		} else {
		node.classList.remove('is-loading');
		}
	}
}

export default Utils;
